import styled from 'styled-components';
import { colors, gridSize } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

// eslint-disable-next-line rulesdir/no-styled-export
export const Outer = styled.div`
    display: flex;
    padding: ${token('space.100', '8px')} ${token('space.200', '16px')};

    &:hover {
        background-color: ${token('elevation.surface.overlay.hovered', colors.N30)};
    }
`;

// eslint-disable-next-line rulesdir/no-styled-export
export const Icon = styled.div`
    margin-right: ${token('space.150', '12px')};
    flex-shrink: 0;
`;

// eslint-disable-next-line rulesdir/no-styled-export
export const Content = styled.div`
    color: ${token('color.text', colors.N800)};
`;

// eslint-disable-next-line rulesdir/no-styled-export
export const PrimaryAttribute = styled.div`
    line-height: ${gridSize() * 3}px;
    font-weight: 500;
`;

// eslint-disable-next-line rulesdir/no-styled-export
export const SecondaryAttributes = styled.div`
    font-size: ${gridSize() * 1.5}px;
    line-height: ${gridSize() * 2}px;
`;
